import { MenuItem } from "@mui/material";
import { useField } from "formik";
import { ReactElement } from "react";

import { FormikSelect } from "~frontend/components/forms/FormSelect";

import { OwnedPhoneNumberPool } from "../types";

export default function OwnedPhoneNumberPoolPicker({
  readOnly,
  name,
  ownedPhoneNumberPools,
}: {
  readOnly?: boolean;
  name: string;
  ownedPhoneNumberPools: OwnedPhoneNumberPool[];
}): ReactElement {
  const [field] = useField<string>(name);

  const availablePools = ownedPhoneNumberPools.filter(p => !p.archivedAt);
  const currentPoolId = field.value;

  let currentButInvalidPool: OwnedPhoneNumberPool | undefined = undefined;
  if (currentPoolId && !availablePools.find(p => p.id === currentPoolId)) {
    currentButInvalidPool = ownedPhoneNumberPools.find(
      p => p.id === currentPoolId
    );
  }

  return (
    <FormikSelect
      name={name}
      fullWidth
      label="Phone Number Pool"
      disabled={readOnly}
    >
      {currentButInvalidPool && (
        <MenuItem disabled value={currentButInvalidPool.id}>
          {currentButInvalidPool.name} (not available)
        </MenuItem>
      )}

      {availablePools.map(phoneNumberPool => {
        return (
          <MenuItem key={phoneNumberPool.id} value={phoneNumberPool.id}>
            {phoneNumberPool.name}
          </MenuItem>
        );
      })}
    </FormikSelect>
  );
}
